import styles from './sticky-bar.module.scss';
import { ReactNode } from 'react';

export const StickyBar = ({ children }: { children: ReactNode }) => <div className={styles.container}>{children}</div>;
